function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Input, Menu } from "@material-ui/core";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import ReactTooltip from "react-tooltip";
import { openModal } from "@common/actions";
import { CATEGORIES_ALL_ID, CATEGORIES_CHANNELS_CONFIG, CATEGORIES_EPGS_CONFIG, FILTER_TYPE_LIVE, KEY_ENTER, KEY_SPACE, SEARCH_DEBOUNCE_TIME, SETTINGS, TOOLTIP_SHOW_DELAY } from "@config/constants";
export var CategoryFilters = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    _inherits(CategoryFilters, PureComponent);
    var _super = _create_super(CategoryFilters);
    function CategoryFilters(props) {
        _class_call_check(this, CategoryFilters);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            selected: _this.props.searchState.category >= 0 ? _this.props.searchState.category : CATEGORIES_ALL_ID,
            searchStringValue: _this.props.channelSearchString || "",
            isSearchChannelOpen: false
        };
        _this.filtersMenuRef = null;
        _this.filtersListRef = null;
        _this.alphabeticalFilterRef = null;
        _this.searchTimeout = null;
        _this.setFiltersMenuRef = _this.setFiltersMenuRef.bind(_assert_this_initialized(_this));
        _this.toggleFromKeyboard = _this.toggleFromKeyboard.bind(_assert_this_initialized(_this));
        _this.toggleChannelSearch = _this.toggleChannelSearch.bind(_assert_this_initialized(_this));
        _this.toggleChannelSearchFromKeyboard = _this.toggleChannelSearchFromKeyboard.bind(_assert_this_initialized(_this));
        _this.onFilterClick = _this.onFilterClick.bind(_assert_this_initialized(_this));
        _this.selectCategoryFromKeyboard = _this.selectCategoryFromKeyboard.bind(_assert_this_initialized(_this));
        _this.onAlphabeticalFilterKeyDown = _this.onAlphabeticalFilterKeyDown.bind(_assert_this_initialized(_this));
        _this.handleClickOutside = _this.handleClickOutside.bind(_assert_this_initialized(_this));
        _this.handleClose = _this.handleClose.bind(_assert_this_initialized(_this));
        _this.handleResize = _this.handleResize.bind(_assert_this_initialized(_this));
        _this.handleChannelSearchChange = _this.handleChannelSearchChange.bind(_assert_this_initialized(_this));
        _this.handleChannelSearchKeyPress = _this.handleChannelSearchKeyPress.bind(_assert_this_initialized(_this));
        return _this;
    }
    _create_class(CategoryFilters, [
        {
            /**
     * Toggles the list with categories from keyboard
     * @param event {Object}
     */ key: "toggleFromKeyboard",
            value: function toggleFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_SPACE || key === KEY_ENTER) {
                    this.props.toggleCategoryFilter();
                }
            }
        },
        {
            /**
     * Calls the `onChange` props callback
     * with the selected categoryId value.
     * Also toggles the list.
     * @param {number} categoryId
     */ key: "onFilterClick",
            value: function onFilterClick(categoryId) {
                var selected = this.state.selected;
                var onChange = this.props.onChange;
                var value = selected === categoryId ? CATEGORIES_ALL_ID : categoryId;
                if (!this.props.screenType.web) {
                    this.handleClose();
                }
                if (typeof onChange === "function") {
                    onChange(value);
                }
            }
        },
        {
            /**
     * Selects category filter on space/enter keydown
     * @params event {Object} categoryId {Number}
     */ key: "selectCategoryFromKeyboard",
            value: function selectCategoryFromKeyboard(event, categoryId) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.onFilterClick(categoryId);
                }
            }
        },
        {
            /**
     * Updates the search string value in the state
     * Sets debounce for the search callback method and calls it from the props
     * @param event {Object}
     */ key: "handleChannelSearchChange",
            value: function handleChannelSearchChange(event) {
                var _this = this;
                var stringValue = event.target.value;
                this.setState({
                    searchStringValue: stringValue
                });
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(function() {
                    _this.props.onChannelSearchChange(stringValue);
                }, SEARCH_DEBOUNCE_TIME);
            }
        },
        {
            /**
     * On 'Enter' key press resets the timeout and calls the search method from the props
     * @param event {Object}
     */ key: "handleChannelSearchKeyPress",
            value: function handleChannelSearchKeyPress(event) {
                var key = event.which;
                if (key === KEY_ENTER) {
                    clearTimeout(this.searchTimeout);
                    this.props.onChannelSearchChange(event.target.value);
                }
            }
        },
        {
            /**
     * Handles the toggle of the alphabetical filter from keyboard
     * @param event {Object}
     */ key: "onAlphabeticalFilterKeyDown",
            value: function onAlphabeticalFilterKeyDown(event) {
                var key = event.which;
                if (key === KEY_ENTER || key === KEY_SPACE) {
                    this.props.onAlphabeticalFilterChange(!this.alphabeticalFilterRef.checked);
                }
            }
        },
        {
            /**
     * Updates the filter anchor reference
     * @param {Object} node
     * @param {Boolean} isMobile - if the given node is the anchor for mobile or web view
     */ key: "setFiltersMenuRef",
            value: function setFiltersMenuRef(node, isMobile) {
                if (!isMobile && this.props.screenType.web || isMobile && !this.props.screenType.web) {
                    this.filtersMenuRef = node;
                }
            }
        },
        {
            /**
     *  Handles click outside of filters menu and calls
     *  handleClose method if click is outside filters menu
     *  @param {Object} event
     */ key: "handleClickOutside",
            value: function handleClickOutside(event) {
                if (this.filtersMenuRef && this.filtersMenuRef.contains(event.target)) {
                    return;
                }
                // Keeps the category filters menu open while scrolling via touch on the mobile view
                if (!this.props.screenType.web && this.filtersListRef && this.filtersListRef.contains(event.target)) {
                    return;
                }
                this.handleClose();
            }
        },
        {
            /**
     * Closes the category filters menu
     */ key: "handleClose",
            value: function handleClose() {
                this.props.closeCategoryFilter();
            }
        },
        {
            /**
     * Toggles the search channel on mobile view
     * @param shouldClose {Boolean || Undefined}
     */ key: "toggleChannelSearch",
            value: function toggleChannelSearch(shouldClose) {
                var isSearchChannelOpen = shouldClose ? false : !this.state.isSearchChannelOpen;
                this.setState({
                    isSearchChannelOpen: isSearchChannelOpen
                });
            }
        },
        {
            /**
     * Toggles the channel search from the keyboard
     * @param event {Object}
     */ key: "toggleChannelSearchFromKeyboard",
            value: function toggleChannelSearchFromKeyboard(event) {
                var key = event.which;
                if (key === KEY_ENTER || KEY_SPACE) {
                    this.toggleChannelSearch();
                }
            }
        },
        {
            /**
     * Handles screen resize by closing the category filter menu and the channel search
     */ key: "handleResize",
            value: function handleResize() {
                this.handleClose();
                this.toggleChannelSearch(true);
            }
        },
        {
            /**
     * Render category filters
     * @returns {ReactElement || null}
     */ key: "render",
            value: function render() {
                var _this = this;
                var categoryFilterTemplate = null;
                var filtersMenu = null;
                var _this_state = this.state, selected = _this_state.selected, searchStringValue = _this_state.searchStringValue, isSearchChannelOpen = _this_state.isSearchChannelOpen;
                var _this_props = this.props, categories = _this_props.categories, i18n = _this_props.i18n, _$openModal = _this_props.openModal, screenType = _this_props.screenType, representedCategories = _this_props.representedCategories, filterType = _this_props.filterType, videoPlayer = _this_props.videoPlayer, toggleCategoryFilter = _this_props.toggleCategoryFilter, isCategoriesFilterOpen = _this_props.isCategoriesFilterOpen, isAlphabeticalFilterChecked = _this_props.isAlphabeticalFilterChecked, onAlphabeticalFilterChange = _this_props.onAlphabeticalFilterChange;
                var categoriesIds = Object.keys(categories);
                var areCategoriesReady = categoriesIds.length > 0;
                var categoriesConfig = filterType === FILTER_TYPE_LIVE ? CATEGORIES_CHANNELS_CONFIG : CATEGORIES_EPGS_CONFIG;
                if (areCategoriesReady) {
                    var categoryId = categories[selected] ? categories[selected].position : CATEGORIES_ALL_ID;
                    var selectedFilterName = selected !== CATEGORIES_ALL_ID && categories[selected] ? categories[selected].name : i18n.search.filterAll;
                    var filtersMenuOptions = categoriesIds.map(function(id) {
                        var name = categories[id].name;
                        var categoryId = categories[id].position;
                        var isAvailable = _to_consumable_array(representedCategories).filter(function(item) {
                            return item === categoryId;
                        }).length > 0;
                        var onClickHandler = isAvailable ? function() {
                            return _this.onFilterClick(categoryId);
                        } : function() {
                            return null;
                        };
                        var filterClass = "";
                        if (!isAvailable) {
                            filterClass += " not-available";
                        }
                        var isSelected = categoryId === selected;
                        if (isSelected) {
                            filterClass += " selected";
                        }
                        // Add default icon when new/different category added.
                        var categoryIconClass = categoriesConfig[categoryId] ? categoriesConfig[categoryId].iconClass : categoriesConfig[CATEGORIES_ALL_ID].iconClass;
                        return /*#__PURE__*/ _jsxs("span", {
                            className: "menu-item ".concat(filterClass),
                            tabIndex: isCategoriesFilterOpen ? "0" : "-1",
                            onKeyDown: function(event) {
                                return _this.selectCategoryFromKeyboard(event, categoryId);
                            },
                            onClick: onClickHandler,
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: categoryIconClass
                                }),
                                name
                            ]
                        }, id);
                    });
                    var paperStyles;
                    var menuProps = {};
                    var topPosition = this.filtersMenuRef && !screenType.web ? "".concat(this.filtersMenuRef.offsetTop + this.filtersMenuRef.clientHeight, "px") : 0;
                    if (screenType.web) {
                        paperStyles = {
                            marginTop: "25px",
                            marginLeft: "-25px"
                        };
                    } else {
                        menuProps.anchorReference = "none";
                        paperStyles = {
                            top: topPosition,
                            left: 0,
                            width: "100%",
                            maxWidth: "unset",
                            maxHeight: "calc(100% - ".concat(topPosition, ")"),
                            boxShadow: "unset"
                        };
                    }
                    // Sets the category option for all filters
                    filtersMenuOptions.unshift(/*#__PURE__*/ _jsxs("span", {
                        className: "menu-item".concat(selected === CATEGORIES_ALL_ID ? " selected" : ""),
                        tabIndex: isCategoriesFilterOpen ? "0" : "-1",
                        onKeyDown: function(event) {
                            return _this.selectCategoryFromKeyboard(event, CATEGORIES_ALL_ID);
                        },
                        onClick: function() {
                            return _this.onFilterClick(CATEGORIES_ALL_ID);
                        },
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: categoriesConfig[CATEGORIES_ALL_ID].iconClass
                            }),
                            i18n.search.filterAll
                        ]
                    }, CATEGORIES_ALL_ID));
                    filtersMenu = /*#__PURE__*/ _jsx("div", {
                        id: "menu-list-grow",
                        children: /*#__PURE__*/ _jsx(Menu, _object_spread_props(_object_spread({
                            className: "menu",
                            id: "filters-menu",
                            anchorEl: this.filtersMenuRef,
                            getContentAnchorEl: null,
                            open: isCategoriesFilterOpen,
                            disablescrolllock: "true",
                            onClose: this.handleClose
                        }, menuProps), {
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "left"
                            },
                            transformOrigin: {
                                vertical: "top",
                                horizontal: screenType.web ? "left" : "center"
                            },
                            PaperProps: {
                                style: _object_spread({}, paperStyles)
                            },
                            children: !screenType.web ? /*#__PURE__*/ _jsx("div", {
                                ref: function(ref) {
                                    return _this.filtersListRef = ref;
                                },
                                tabIndex: "-1",
                                children: filtersMenuOptions
                            }) : filtersMenuOptions
                        }))
                    });
                    var channelSearchIcon = isSearchChannelOpen ? "icon-clear" : "icon-search";
                    var channelSearchStateClass = isSearchChannelOpen || screenType.web ? "channel-search-open" : "channel-search-close";
                    var categoryFilterClasses = " opened";
                    categoryFilterClasses += videoPlayer && videoPlayer.isOpen && !screenType.mobile ? " no-height" : "";
                    categoryFilterTemplate = /*#__PURE__*/ _jsxs("div", {
                        ref: function(ref) {
                            return _this.setFiltersMenuRef(ref, true);
                        },
                        className: "category-filter-container".concat(categoryFilterClasses),
                        children: [
                            /*#__PURE__*/ _jsx(ReactTooltip, {
                                id: "category-filter-tooltip",
                                className: "tooltip",
                                disable: !screenType.web,
                                delayShow: TOOLTIP_SHOW_DELAY,
                                place: "bottom",
                                effect: "solid"
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "filters-wrapper",
                                children: [
                                    filterType === FILTER_TYPE_LIVE ? /*#__PURE__*/ _jsxs("div", {
                                        className: "name-search-wrapper",
                                        children: [
                                            /*#__PURE__*/ _jsx(Input, {
                                                onChange: this.handleChannelSearchChange,
                                                onKeyPress: this.handleChannelSearchKeyPress,
                                                type: "text",
                                                className: "ux-input ".concat(channelSearchStateClass),
                                                value: searchStringValue,
                                                inputProps: {
                                                    tabIndex: isSearchChannelOpen ? "0" : "-1"
                                                },
                                                placeholder: i18n.common.searchForChannel
                                            }),
                                            screenType.web ? /*#__PURE__*/ _jsx("span", {
                                                className: "icon icon-search"
                                            }) : /*#__PURE__*/ _jsx("span", {
                                                tabIndex: "0",
                                                className: "icon ".concat(channelSearchIcon, " pointer active"),
                                                onClick: function() {
                                                    return _this.toggleChannelSearch();
                                                },
                                                onKeyPress: this.toggleChannelSearchFromKeyboard
                                            })
                                        ]
                                    }) : null,
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "category-and-alphabetical-wrapper",
                                        children: [
                                            filterType === FILTER_TYPE_LIVE ? /*#__PURE__*/ _jsx("div", {
                                                className: "alphabetical-filter",
                                                children: /*#__PURE__*/ _jsxs("label", {
                                                    className: "alphabetical-filter-switch",
                                                    tabIndex: "0",
                                                    onKeyDown: function(event) {
                                                        return _this.onAlphabeticalFilterKeyDown(event);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("input", {
                                                            ref: function(ref) {
                                                                return _this.alphabeticalFilterRef = ref;
                                                            },
                                                            type: "checkbox",
                                                            tabIndex: "-1",
                                                            onChange: function(event) {
                                                                return onAlphabeticalFilterChange(event.target.checked);
                                                            },
                                                            checked: isAlphabeticalFilterChecked
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "alphabetical-filter-slider",
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                className: "alphabetical-filter-title",
                                                                children: "А-Я"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : null,
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "category-filter-wrapper",
                                                children: [
                                                    screenType.web ? /*#__PURE__*/ _jsx("span", {
                                                        className: "filters-label",
                                                        children: "".concat(i18n.search.filter, ":")
                                                    }, i18n.search.filter) : null,
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        tabIndex: "0",
                                                        ref: function(ref) {
                                                            return _this.setFiltersMenuRef(ref, false);
                                                        },
                                                        "aria-controls": "menu-list-grow",
                                                        "aria-haspopup": "true",
                                                        className: "category-filter available selected",
                                                        onKeyDown: this.toggleFromKeyboard,
                                                        onClick: toggleCategoryFilter,
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: categoriesConfig[categoryId] ? categoriesConfig[categoryId].iconClass : categoriesConfig[CATEGORIES_ALL_ID].iconClass
                                                            }),
                                                            screenType.web ? selectedFilterName : null,
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "icon-2 icon-arrow-filters ".concat(isCategoriesFilterOpen ? "open" : "closed")
                                                            })
                                                        ]
                                                    }),
                                                    filtersMenu
                                                ]
                                            })
                                        ]
                                    }),
                                    filterType === FILTER_TYPE_LIVE ? /*#__PURE__*/ _jsx("div", {
                                        tabIndex: "0",
                                        className: "settings-menu-wrapper pointer",
                                        onClick: function() {
                                            return _$openModal(SETTINGS, {
                                                activeComponentName: "ChangeView",
                                                shouldModalCloseOnSave: true
                                            });
                                        },
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "icon-2 icon-settings-menu"
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    });
                }
                return categoryFilterTemplate;
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("click", this.handleClickOutside);
                document.addEventListener("touchend", this.handleClickOutside);
                document.addEventListener("resize", this.handleResize);
                this.setState({
                    selected: this.props.searchState.category >= 0 ? this.props.searchState.category : CATEGORIES_ALL_ID
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.closeCategoryFilter();
                document.removeEventListener("click", this.handleClickOutside);
                document.removeEventListener("touchend", this.handleClickOutside);
                document.removeEventListener("resize", this.handleResize);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState, prevContext) {
                if (prevProps.searchState.category !== this.props.searchState.category) {
                    this.setState({
                        selected: this.props.searchState.category >= 0 ? this.props.searchState.category : CATEGORIES_ALL_ID
                    });
                }
                if (prevProps.isCategoriesFilterOpen !== this.props.isCategoriesFilterOpen && this.props.isCategoriesFilterOpen && this.filtersMenuRef) {
                    this.filtersMenuRef.focus();
                }
            }
        }
    ]);
    return CategoryFilters;
}(PureComponent);
var mapStateToProps = function(param) {
    var profileSettings = param.profileSettings, videoPlayer = param.videoPlayer, searchState = param.searchState;
    return {
        profileSettings: profileSettings,
        videoPlayer: videoPlayer,
        searchState: searchState
    };
};
export default connect(mapStateToProps, {
    openModal: openModal
})(CategoryFilters);
